import { render } from "./WcoinModal.vue?vue&type=template&id=c6075e18"
import script from "./WcoinModal.vue?vue&type=script&lang=js"
export * from "./WcoinModal.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/SSD/jenkins/workspace/Walk Online Mobile/Walk Online Admin/Walk Online Admin Prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__